import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { selectLoginState } from '@store';
import { useAssignees } from 'hooks/common';

export const useSideBarTicketCreation = () => {
  const router = useRouter();
  const { user } = useSelector(selectLoginState);
  const { assignees: agents } = useAssignees({ enabled: router.isReady });

  return {
    currentUser: user,
    agents,
  };
};
